import { getExtensions } from '@/components/tiptap-editor/tiptap-editor';
import { migrateZybookMathStrings } from '@/components/tiptap-editor/tiptap-extension/math-extension';
import { Editor, type JSONContent } from '@tiptap/react';
import { type Section, zybookSectionToProseMirrorJson } from './from-zyxml';

/**
 * Converts a zyAuthor `zyXml_to_json` section (import-side shape with `content_resources`)
 * to TipTap/ProseMirror JSON, applying the same math migration as zyXML import in EditorDev.
 * Optionally merges attributes onto the document node (e.g. sandbox demo doc attrs).
 *
 * Callers may pass loosely typed JSON (`Record<string, unknown>`); runtime shape must match `Section`.
 */
export async function sectionToMigratedProseMirrorJson(section: Section | Record<string, unknown>): Promise<JSONContent> {
    const pm = await zybookSectionToProseMirrorJson(section as Section);
    const editor = new Editor({
        element: document.createElement('div'),
        extensions: getExtensions(),
        content: pm,
    });
    migrateZybookMathStrings(editor);
    const json = editor.getJSON();
    editor.destroy();

    return json;
}
